import React from 'react'

const About = () => {
  return (
    <div name="about" className='w-full h-screen bg-[#0a192f] text-gray-300'>
        <div className='flex flex-col justify-center items-center w-full h-full animate'>
            <div className='max-w-[1000px] w-full px-4 grid grid-cols-2 gap-8'>
                <div className='sm:text-rigth pb-8 pl-4'>
                    <p className='text-4xl font-bold inline border-b-4 border-pink-600'>About</p>
                </div>
                <div>
                </div>
            </div>
            <div className='max-w-[1000px] w-full px-4 grid sm:grid-cols-2 gap-8'>
                <div className='sm:text-right text-4xl font-bold'>
                    <p>Hi I am Saransh. Nice to meet you. Please have a look around</p>
                </div>
                <div>
                    <p>
                    Front End Developer with a proven ability to collaborate effectively with senior developers while spending extra time to be mentored. 
                    Enjoy working closely with team members to ensure 
                    workloads are effectively redirected to bottlenecks and personally picking up the slack when necessary. With a 
                    passion for both personal growth and for software development.
                    </p>
                </div>
            </div>
        </div>
    </div>
  )
}

export default About